import { Button, Intent, Menu, MenuItem, Tooltip } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { IWidgetProps } from "decorator-form";
import * as React from "react";

import { registerWidget } from "common/form/register";
import IOption from "common/models/IOption";
import { arrayMove } from "core/util/ArrayUtils";
import { StyledItem, StyledListContainer } from "./fragments";
import ListItem from "./ListItem";

/**
 * @author chris
 * @description
 * 	sort a list of strings, and optionally remove/disable some.
 * 	might be useful for ordering/configuring sort options, table columns, etc.
 */


interface IListOrderWidgetProps extends IWidgetProps<string[]> {
	canDisableOptions?: boolean;
	options: IOption[];
}

interface IOptionMap {
	[key: string]: IOption;
}

export default class ListOrderWidget extends React.PureComponent<IListOrderWidgetProps> {

	public static withOptions(options: IOption[], canDisableOptions: boolean = true) {
		return (props: IWidgetProps<string[]>) => <ListOrderWidget {...props} options={options} canDisableOptions={canDisableOptions} />;
	}

	public static registerWithOptions(options: IOption[], canDisableOptions?: boolean) {
		return registerWidget(this.withOptions(options, canDisableOptions), "string");
	}

	public render() {
		const { canDisableOptions, options, value } = this.props;

		const optionMap: IOptionMap = options.reduce((a, c) => {
			a[c.value] = c;
			return a;
		}, {});

		const activeOptions: IOption[] = value ? this.getOptionsForValues(optionMap, value) : options;
		const disabledOptions: IOption[] = value ? this.getOptionsForValues(optionMap, options.map((o) => o.value).filter((ov) => value.indexOf(ov) < 0)) : undefined;

		return (
			<Menu>
				{
					activeOptions.map((o, i) => {

						return (
							<ListItem
								key={o.value}
								index={i}
								id={o.value}
								moveItem={this.moveItem}
							>
								<MenuItem
									labelElement={
										canDisableOptions && (
											<Tooltip content="Remove">
												<Button
													intent={Intent.DANGER}
													small={true}
													minimal={true}
													onClick={() => this.disableItem(i)}
													icon={IconNames.REMOVE}
												/>
											</Tooltip>
										)
									}
									style={{cursor: "move"}}
									text={o.label}
								/>
							</ListItem>
						);
					})
				}
				{
					disabledOptions && disabledOptions.map((o) => (
						<MenuItem
							disabled={true}
							labelElement={
								<Tooltip content="Add">
									<Button
										small={true}
										minimal={true}
										onClick={() => this.activateItem(o.value)}
										icon={IconNames.ADD}
										intent={Intent.SUCCESS}
									/>
								</Tooltip>
							}
							key={o.value}
							text={o.label}
						/>
					))
				}
			</Menu>
		);
	}

	private disableItem = (index: number) => {
		const list = this.props.value || this.props.options.map((o) => o.value);
		this.props.onChange(list.filter((_, i) => index !== i));
	}

	private activateItem = (value: string) => {
		this.props.onChange(this.props.value ? [...this.props.value, value] : [value]);
	}

	private moveItem = (dragIndex: number, hoverIndex: number) => {
		const list = this.props.value || this.props.options.map((o) => o.value);

		this.props.onChange(arrayMove([...list], dragIndex, hoverIndex));
	}

	private getOptionsForValues = (optionMap: IOptionMap, values: string[]): IOption[] => {
		return values.filter((v) => optionMap[v] !== undefined).map((v) => optionMap[v]);
	}
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/listOrder/ListOrderWidget.tsx